import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './GoToDashboardButton.module.css';

const GoToDashboardButton = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleRedirect = () => {
    navigate('/dashboard');
  };

  return (
    <button onClick={handleRedirect} className={styles.dashboardButton}>
      <span className={styles.dashboardIcon}>⌂</span>
      <span>{t('Dashboard')}</span>
    </button>
  );
};

export default GoToDashboardButton;
